//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import formPage from './form'
import couponItem from './component/coupon-item'

export default {
    components: {formPage, couponItem},
    props: [],
    data () {
        return {
            tableData: [],
            pgData: {},

            dialogVisible: false,
            dialogTitle: '',

            formSearch: {
                rowguid: ''
            }
        }
    },
    watch: {
        dialogVisible(n, o) {
            !n && this.reloadHandler();
        }
    },
    methods: {
        addHandler() {
            this.dialogTitle = '添加优惠券';
            this.formSearch.rowguid = '';
            this.dialogVisible = true;
        },
        editHandler(row) {
            this.dialogTitle = '编辑优惠券';
            this.formSearch.rowguid = row.rowguid;
            this.dialogVisible = true;
        },
        delHandler(row) {
            this.$post(this.getStore('finUrl') + '/coupon/del', {
                rowguid: row.rowguid
            }, (data, res) => {
                ShowMsg.call(this, res.msg);
                this.reloadHandler();
            })
        },
        reloadHandler() {
            this.$refs.page.reload();
        },
        timeChange(e, row) {
            row.starttime = e ? e[0] : '';
            row.endtime = e ? e[1] : '';

            this.itemIsUseChange(e, row);
        },
        afterQuery(data) {
            data.forEach(function(item) {
                item.time = [item.starttime || '', item.endtime || ''];
            })
        },
        itemIsUseChange(e, row) {
            this.$post(this.getStore('finUrl') + '/coupon/reuse', row, (data, res) => {
                ShowMsg.call(this, res.msg, 'success')
            })
        }
    },
    mounted: function() {

    }
}
